/**
 * Footer menu accordion functionality
 */
export function initFooterMenu() {
	if (typeof jQuery === 'undefined') {
		return;
	}

	const $ = jQuery;

	$(document).ready(function() {
		$('.footer-menu-toggle').on('click', function(e) {
			e.preventDefault();
			
			const $button = $(this);
			const $target = $('#' + $button.data('target'));
			const $icon = $button.find('.footer-menu-icon');
			const $plusIcon = $button.find('.plus-icon');
			const $minusIcon = $button.find('.minus-icon');
			const isExpanded = $button.attr('aria-expanded') === 'true';
			
			// Toggle aria-expanded
			$button.attr('aria-expanded', !isExpanded);
			
			// Toggle submenu visibility
			if (isExpanded) {
				// Collapse
				$target.slideUp(300);
				$plusIcon.removeClass('hidden');
				$minusIcon.addClass('hidden');
			} else {
				// Expand
				$target.slideDown(300);
				$plusIcon.addClass('hidden');
				$minusIcon.removeClass('hidden');
			}
		});
	});
}

